module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.8b43027.eot";